<template>
	<AppDialog ref="dialog_container" dialogName="EmailDomainInfoDialog" width="625px">
		<Col class="email-domain-info-dialog flex-justify-space-between">
			<div>
				<h1 class="dialog-title flex flex-justify-start pl-0">Connect your domain to Ply</h1>
				<h3 class="mt-1">Set the following record on your DNS provider to continue:</h3>
				<h5 class="mb-2 med">
					Not sure how? <a><u @click="openInstructions">Here's a guide</u></a>
				</h5>
				<div class="font-size-lg font-weight-500 mt-5">DKIM</div>
				<Row>Type: txt</Row>
				<Row class="copy-link-row"
					><span class="copy-link-value">Hostname: </span>
					<AppTextField class="width-100" disabled v-model="dkimHost" outlined hide-details />
					<LinkCopy hideText preventOpenLink class="link-copy-wrapper" :src="dkimHost"
				/></Row>
				<Row class="copy-link-row">
					<span class="copy-link-value">Value: </span>
					<AppTextField class="width-100" disabled v-model="dkim" outlined hide-details />
					<LinkCopy hideText preventOpenLink class="link-copy-wrapper" :src="dkim" />
				</Row>
				<div class="font-size-lg font-weight-500 mt-5">Return-Path</div>
				<Row>Type: CNAME</Row>
				<Row class="copy-link-row"
					><span class="copy-link-value">Hostname: </span>
					<AppTextField class="width-100" disabled v-model="returnPathHost" outlined hide-details />
					<LinkCopy hideText preventOpenLink class="link-copy-wrapper" :src="returnPathHost"
				/></Row>
				<Row class="copy-link-row">
					<span class="copy-link-value">Value: </span>
					<AppTextField class="width-100" disabled v-model="returnPathCnameVal" outlined hide-details />
					<LinkCopy hideText preventOpenLink class="link-copy-wrapper" :src="returnPathCnameVal" />
				</Row>
				<h5 class="mt-5 med">It usually takes 10 minutes for DNS to propagate, and can take up to 24 hours.</h5>
			</div>
			<Row class="flex-justify-center mb-5">
				<PrimaryButton @click="verifyConfiguration">Verify Configuration</PrimaryButton>
			</Row>
		</Col>
	</AppDialog>
</template>

<script>
import LinkCopy from '@/components/common/LinkCopy/LinkCopyMinimal';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'EmailDomainInfoDialog',
	components: { AppDialog, LinkCopy },
	props: { dialogPromiseHandlers: { type: Object }, domain: { type: Object } },
	methods: {
		stripDomainFromEnding(str) {
			return str.endsWith(`.${this.domain.domain}`) ? str.split(`.${this.domain.domain}`)[0] : str;
		},
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		openInstructions() {
			alert('Instructions TODO');
		},
		readVercelInstructions() {
			alert('Vercel Instructions TODO');
		},
		verifyConfiguration() {
			this.dialogPromiseHandlers.resolve({ domainId: this.domain.id });
			this.close();
		},
	},
	data() {
		return {
			dkim: this.domain.dkim,
			dkimHost: this.stripDomainFromEnding(this.domain.dkim_host),
			returnPathHost: this.stripDomainFromEnding(this.domain.return_path_domain),
			returnPathCnameVal: this.domain.return_path_domain_cname_val,
		};
	},
};
</script>

<style scoped lang="scss">
.copy-link-value {
	margin-top: 1%;
	margin-right: 10px;
}
.copy-link-row {
	margin-top: 12px;
	height: 35px;
}

.link-copy-wrapper {
	max-width: 240px;
}
.email-domain-info-dialog {
	height: 700px;
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;
	padding: 20px 30px 14px 30px;
}
</style>
